import { useTranslation } from 'libs/i18n'
import type { PayoutMethodKind } from 'shared/types/payout.types'

export const usePayoutMethodLabels = (): Record<PayoutMethodKind, string> => {
	const { t } = useTranslation()

	return {
		bank: t('Bank account'),
		bizum: t('Bizum')
	}
}
